import request from '@/utils/request'

// 获取定时任务列表
export function getJobList(params) {
  return request({
    url: '/api/v1/jobs',
    method: 'get',
    params
  })
}

// 获取定时任务详情
export function getJobDetail(id) {
  return request({
    url: `/api/v1/jobs/${id}`,
    method: 'get'
  })
}

// 保存定时任务
export function saveJob(data) {
  return request({
    url: '/api/v1/jobs',
    method: 'post',
    data
  })
}

// 修改定时任务
export function updateJob(data) {
  return request({
    url: '/api/v1/jobs',
    method: 'put',
    data
  })
}

// 批量删除定时任务
export function deleteJobs(ids) {
  return request({
    url: '/api/v1/jobs/batch',
    method: 'delete',
    data: ids
  })
}

// 立即执行
export function runJobs(ids) {
  return request({
    url: '/api/v1/jobs/run',
    method: 'post',
    data: ids
  })
}

// 暂停任务
export function pauseJobs(ids) {
  return request({
    url: '/api/v1/jobs/pause',
    method: 'post',
    data: ids
  })
}

// 恢复任务
export function resumeJobs(ids) {
  return request({
    url: '/api/v1/jobs/resume',
    method: 'post',
    data: ids
  })
}

// 获取定时任务日志列表
export function getJobLogList(params) {
  return request({
    url: '/api/v1/jobs/logs',
    method: 'get',
    params
  })
}

// 获取定时任务日志详情
export function getJobLogDetail(id) {
  return request({
    url: `/api/v1/jobs/logs/${id}`,
    method: 'get'
  })
}
